import { jwtDecode } from 'jwt-decode';
import React, { useEffect, useState } from 'react';
import { Route, BrowserRouter as Router, Routes, useNavigate } from 'react-router-dom';
import './App.css';
import Auth from './components/Auth';
import BuyTransactionForm from './components/BuyTransactionForm';
import Footer from './components/Footer';
import Header from './components/Header';
import KYC from './components/KYC';
import SellTransactionForm from './components/SellTransactionForm';
import ServicePaymentForm from './components/ServicePaymentForm';
import ServicePaymentPage from './components/ServicePaymentPage';
import ServicePaymentWizard from './components/ServicePaymentWizard';
import TransactionPage from './components/TransactionPage';
import { WalletProvider } from './context/WalletContext';
import CowSwap from './pages/CowSwap';
import Disclaimer from './pages/Disclaimer';
import JupSwap from './pages/JupSwap';
import TransactionsList from './pages/TransactionsList';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (!token) {
      navigate('/auth');
    } else {
      try {
        const decoded: any = jwtDecode(token);
        const currentTime = Date.now() / 1000;
        if (decoded.exp < currentTime) {
          localStorage.removeItem('authToken');
          navigate('/auth');
        }
      } catch (error) {
        console.error('Invalid token:', error);
        localStorage.removeItem('authToken');
        navigate('/auth');
      }
    }
  }, [navigate]);

  return <>{children}</>;
};

const HomePage: React.FC<{ currentTab: 'buy' | 'sell'; handleTabSwitch: (tab: 'buy' | 'sell') => void }> = ({
  currentTab,
  handleTabSwitch,
}) => {
  return (
    <>
      <div className='ramp-container'>
        <div className="tab-selector">
          <button
            className={`tab ${currentTab === 'buy' ? 'active' : ''}`}
            onClick={() => handleTabSwitch('buy')}
          >
            Comprar
          </button>
          <button
            className={`tab ${currentTab === 'sell' ? 'active' : ''}`}
            onClick={() => handleTabSwitch('sell')}
          >
            Vender
          </button>
        </div>
        
          <div className="form-container">
            {currentTab === 'buy' ? <BuyTransactionForm /> : <SellTransactionForm />}
          </div>
      </div>
    </>
  );
};

const SwapPage: React.FC<{ currentSwapTab: 'jupiter' | 'cowswap'; handleSwapTabSwitch: (tab: 'jupiter' | 'cowswap') => void }> = ({
  currentSwapTab,
  handleSwapTabSwitch,
}) => {
  return (
    <>
      <div className='swap-container'>
        <div className="tab-selector">
          <button
            className={`tab ${currentSwapTab === 'jupiter' ? 'active' : ''}`}
            onClick={() => handleSwapTabSwitch('jupiter')}
          >
            Solana
          </button>
          <button
            className={`tab ${currentSwapTab === 'cowswap' ? 'active' : ''}`}
            onClick={() => handleSwapTabSwitch('cowswap')}
          >
            EVM
          </button>
        </div>
        
          <div className="form-container">
            <div style={{ display: currentSwapTab === 'jupiter' ? 'block' : 'none' }}>
              {/* @ts-ignore */}
              <JupSwap />
            </div>
            <div style={{ display: currentSwapTab === 'cowswap' ? 'block' : 'none' }}>
              <CowSwap />
            </div>
          </div>
        </div>
    </>
  );
};

const App: React.FC = () => {
  const [currentTab, setCurrentTab] = useState<'buy' | 'sell'>('buy');

  const handleTabSwitch = (tab: 'buy' | 'sell') => {
    setCurrentTab(tab);
  };

  const [currentSwapTab, setCurrentSwapTab] = useState<'jupiter' | 'cowswap'>('jupiter');

  const handleSwapTabSwitch = (swaptab: 'jupiter' | 'cowswap') => {
    setCurrentSwapTab(swaptab);
  };

  return (
    <WalletProvider>
    <Router>
      <div className="app">
        <Header />
        <Routes>
          <Route path="/auth" element={<Auth />} />
          <Route
            path="/"
            element={<HomePage currentTab={currentTab} handleTabSwitch={handleTabSwitch} />}
          />
          <Route
            path="/ramp"
            element={<HomePage currentTab={currentTab} handleTabSwitch={handleTabSwitch} />}
          />
          <Route
            path="/transactions/:tid"
            element={
              <ProtectedRoute>
                <TransactionPage />
              </ProtectedRoute>
            }
          />
          <Route path="/transactions/:tid" element={<ProtectedRoute><TransactionPage /></ProtectedRoute>} />
          <Route path="/transactions" element={<ProtectedRoute><TransactionsList /></ProtectedRoute>} />
          <Route path="/payments-old" element={<ServicePaymentForm />} />
          <Route path="/payments" element={<ServicePaymentWizard />} />
          <Route path="/payments/:id" element={<ServicePaymentPage />} />
          
          <Route
            path="/swap"
            element={<SwapPage currentSwapTab={currentSwapTab} handleSwapTabSwitch={handleSwapTabSwitch} />}
          />
          <Route path="/kyc" element={<KYC />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
        </Routes>
        <Footer />
      </div>
    </Router>
    </WalletProvider>
  );
};

export default App;
